export default function getQueryParams(locationHref: string): any {
  const queryString = locationHref.split('?')[1];
  if (!queryString) {
    return {};
  }
  const pairs = queryString.split('&');
  const queryParams: Record<string, number | string> = {};
  for (const pair of pairs) {
    const [key, value] = pair.split('=');

    if (key && value) {
      const decodedValue = decodeURIComponent(value);
      const numericValue = Number.parseFloat(decodedValue);

      queryParams[decodeURIComponent(key)] = Number.isFinite(numericValue) && decodedValue.trim() !== ''
        ? numericValue
        : decodedValue;
    }
  }
  return queryParams;
}
